/** Supervisor bulk-hiring QR. Mirrors PermissionCatalog.BulkHiringSessionUse. */
export const SupervisorBulkHiringPermissions = {
  use: 'bulk_hiring_session',
} as const
